import React, { useEffect, useState, useRef } from 'react';
import styles from './SpectatorMicroBench.module.css';
import { HiPencil } from 'react-icons/hi2';
import avatar from './../../../assets/default-avatar.svg';
import Button from '../../ui/Button';


/*function getSpectatorColor(uid) {
  const palette = ['#fca311', '#4ecdc4', '#ff6b6b', '#3a86ff', '#ffbe0b', '#8338ec'];
  let hash = 0;
  for (let c of uid) hash = (hash << 5) - hash + c.charCodeAt(0);
  return palette[Math.abs(hash) % palette.length];
}*/

function getSpectatorColor(uid) {
    /*const palette = [
    '#fca311', '#ff6b6b', '#4ecdc4', '#3a86ff',
    '#ffbe0b', '#8338ec', '#ff006e', '#00b4d8',
  ];*/
  const palette = [
    '#b4dfc2', '#aa5c5c', '#4ecdc4', '#3a86ff',
    '#695596', '#a288c6', '#b4718e', '#00b4d8',
  ];
  let hash = 0;
  for (let i = 0; i < uid.length; i++) {
    hash = uid.charCodeAt(i) + ((hash << 5) - hash);
  }
  return palette[Math.abs(hash) % palette.length];
}

function truncate( str, n, useWordBoundary )
{
  if (str.length <= n) { return str; }
  const subString = str.substr(0, n-1); // the original check
  return (useWordBoundary 
    ? subString.substr(0, subString.lastIndexOf(" ")) 
    : subString) + "\u2026";
};

export default function SpectatorMicroBench({
  spectators = [],
  currentUser,
  statusDraft,
  handleStatusUpdate,
  onOpenEditor,
  arenaMeta,
  reactions = {}
}) {
  const [popups, setPopups] = useState({});
  const prevStatusRef = useRef({});
  const refs = useRef({}); // map of uid => DOM nodes

  const openPopup = (uid) => {
    setPopups(prev => ({ ...prev, [uid]: true }));
    setTimeout(() => setPopups(prev => ({ ...prev, [uid]: false })), 3000);
  };


  useEffect(() => {
    spectators.forEach(s => {
      if (prevStatusRef.current[s.uid] !== s.status) {
        const el = refs.current[s.uid];
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => openPopup(s.uid), 200); // small delay after scroll
      }
    });
    prevStatusRef.current = spectators.reduce((acc, s) => ({ ...acc, [s.uid]: s.status }), {});
  }, [spectators]);


  return (
    <div className={styles.microContainer}>
      {spectators.map(s => {
        const isSelf = s.uid === currentUser.uid;
        const color = getSpectatorColor(s.uid);
        const showPopup = popups[s.uid];
        const reactionCount = reactions[s.uid] || 0;
        return (
          <div key={s.uid} className={styles.microCardWrapper} ref={el => refs.current[s.uid] = el}>
            <div
              className={`${styles.microCard} ${isSelf ? styles.currentUser : ''}`}
              style={{ borderColor: color }}
              onMouseEnter={() => openPopup(s.uid)}
              onMouseLeave={() => setPopups(prev => ({ ...prev, [s.uid]: false }))}>
              <img src={s.profilePicture || avatar} alt={s.username} className={styles.avatar} />
              {reactionCount > 0 && (
                <div className={styles.badge} style={{ backgroundColor: color }}>
                  {reactionCount}
                </div>
              )}

              {showPopup && (
                <div className={styles.speechBubble} style={{ borderColor: color }}>
                  <div className={styles.bubbleArrow} style={{ borderTopColor: color }} />
                  <div className={styles.bubbleName}>{s.username} {isSelf && '(you)'}</div>
                  <div className={styles.bubbleStatus}>{s.status ? truncate(s.status, 100, true) : <em>Watching</em>}</div>
                </div>
              )}
            </div>

            {isSelf && (arenaMeta?.spectators?.features.includes('comments') || arenaMeta?.spectators?.features.includes('questions')) && (
              <Button className={styles.editBtn} onClick={() => onOpenEditor(s.uid)}>
                <HiPencil size={14} />
              </Button>
            )}
          </div>
        );
      })}
    </div>
  );
}

